import React from 'react'
import {Box, Typography, Button, Card, CardContent, Stepper, Step, StepLabel} from "@mui/material";
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import { Rating } from "@mui/material";
import {APP_STATUS, APP_STATUS_VERBOSE} from "../../../../utils/constants";
import CircularProgress from "@material-ui/core/CircularProgress";
import {RATING_STEPS} from "../../../../utils/RatingFlowSteps";
const CPCRatedProgram = ({ data, actions, options }) => {
    const classes = useStyles();
    const { programStatus, programStatusV3,currentStatus,RATING_STEPS } = data;
    const { ViewReportAction } = actions;
    const { } = options;
    const activeStep = RATING_STEPS.findIndex(step => step.status === currentStatus);

    console.log("programStatus:", programStatus);
    console.log("programStatusV3:", programStatusV3);
    const handleViewReport = () => {
        ViewReportAction();
    };
    return (
        <>
            <Box sx={{ p: 3 }}>
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{
                        '& .MuiStepLabel-root .Mui-completed': {
                            color: '#ff6468ff'
                        },
                        '& .MuiStepLabel-root .Mui-active': {
                            color: '#ff6468ff'
                        },
                        '& .MuiStepLabel-root .Mui-disabled': {
                            color: '#ff6468ff',
                            opacity: 0.5
                        },
                        '& .MuiStepConnector-root .MuiStepConnector-line': {
                            borderColor: '#ff6468ff',
                            borderTopWidth: '6px',
                            // marginTop: '-12px'
                        }
                    }}
                >
                    {RATING_STEPS.map((step) => (
                        <Step key={step.label}>
                            <StepLabel
                                StepIconProps={{
                                    sx: {
                                        '&.Mui-completed': {
                                            color: '#ff6468ff',
                                            fontSize: '1.7rem',
                                            '& .MuiStepIcon-text': {
                                                display: 'none'
                                            }
                                        },
                                        '&.Mui-active': {
                                            color: '#ff6468ff',
                                            fontSize: '1.7rem',
                                            '& .MuiStepIcon-text': {
                                                display: 'none'
                                            }
                                        },
                                        fontSize: '1.7rem',
                                        '& .MuiStepIcon-text': {
                                            display: 'none'
                                        }
                                    }
                                }}
                            >
                                {step.label}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>

                <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "75vh",
                    padding: 4,
                }}
            >
                {/*<Typography variant="h3" sx={{ marginBottom: 5}} className={classes.title}>*/}
                {/*    View Your Available Report*/}
                {/*</Typography>*/}
                {
                    (
                        programStatusV3 !== APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED &&
                        programStatusV3 !== APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED &&
                        programStatusV3 !== APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED &&
                        programStatus !== APP_STATUS.WITHDRAWN &&
                        programStatus !== APP_STATUS.REJECTED &&
                        programStatus !== APP_STATUS.HALTED_COLLECT_DATA &&
                        programStatus !== APP_STATUS.HALTED_PROCESS_DATA &&
                        programStatus !== APP_STATUS.HALTED_REPORT
                    ) && (
                        <CircularProgress className={classes.loader}/>
                    )
                }
                <br/>
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: "1.2rem",
                        textAlign: "left",
                        marginBottom: 4,
                        maxWidth: "930px",
                        color: "#000000",
                    }}
                >
                    Thank you for submitting your program and information.
                </Typography>
                <Box sx={{flexDirection:{sm:'row', xs:'column'},marginBottom: 3,}} style={{display:'flex', alignItems:'flex-start',}}>
                <Typography variant="h5" sx={{marginBottom:{xs:'1', sm:'4'}, textAlign: 'center',fontWeight:'bold', fontSize: '25px !important', color: '#000000'}}>
                    Status:
                </Typography>
                    <Typography
                        variant="h6"
                        className={classes.status}
                        sx={{
                            lineHeight:'1.2',
                            marginLeft: 2,
                            color: programStatusV3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED ? '#ff6468' : '#0097a7'
                        }}
                    >
                        {programStatusV3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED ? (
                           " Your program is currently being evaluated. Please wait…"
                        ) : (
                            <>
                                Your DQ Stars Report is Now Ready for Your Viewing! <br />
                                Click Below to View.
                            </>
                        )}
                    </Typography>
                </Box>
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: "1.1rem",
                            textAlign: "left",
                            marginBottom: 2,
                            maxWidth: "960px",
                            color: "#000000",
                        }}
                    >
                        The DQ Conformity Test evaluates and aligns your program with the <strong style={{textDecoration:'underline'}}>Digital Citizenship for Children (DCC) Framework,</strong>
                        {' '}based on the IEEE-DQ Global Standards for digital literacy, digital skills, and digital readiness.
                        These standards have been rigorously mapped against over 100 global digital literacy frameworks, standards, and evidence-based
                        references to ensure a comprehensive and globally relevant evaluation.
                    </Typography>

                    <Button
                        variant="contained"
                        sx={{
                            marginTop: 4,
                            textTransform: "none",
                            backgroundColor: "#ff6468",
                            padding:'10px 40px',
                            lineHeight:'1.2',
                            borderRadius: '12px',
                            fontSize:'18px',
                            color: '#fff',
                            '&:hover': {
                                backgroundColor: "#ff6468",
                            },
                            "&.Mui-disabled": {
                                backgroundColor: "#cad1d8ff",
                                color: "#ffffff",
                            },
                        }}
                        disabled={programStatusV3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED}
                        onClick={handleViewReport}
                    >
                        View Summary <br/>Report
                    </Button>


                {/*<Box className={classes.cardsContainer}>*/}
                {/*    <Card*/}
                {/*        sx={{*/}
                {/*            width: "350px",*/}
                {/*            borderRadius: "12px",*/}
                {/*            boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2)",*/}
                {/*            textAlign: "center",*/}
                {/*            padding: 2,*/}
                {/*            backgroundColor: "#fff",*/}
                {/*        }}*/}
                {/*    >*/}
                        {/*<Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>*/}
                        {/*    <Rating*/}
                        {/*        value={2}*/}
                        {/*        max={3}*/}
                        {/*        readOnly*/}
                        {/*        icon={<span style={{color: "#FFD700", fontSize: "80px"}}>★</span>}*/}
                        {/*        emptyIcon={<span style={{color: "#E0E0E0", fontSize: "80px"}}>★</span>}*/}
                        {/*    />*/}
                        {/*</Box>*/}
                    {/*    <Typography variant="h4" sx={{marginTop: 2, }} className={classes.cardTitle}>*/}
                    {/*      CPC Stars Report*/}
                    {/*    </Typography>*/}
                    {/*    <Typography variant="body1" sx={{ color: "#666",marginBottom: 4 }}>*/}
                    {/*        This rating showcases how comprehensive your program’s content is against*/}
                    {/*        the CPC’s Cyber Citizenship Framework.*/}
                    {/*    </Typography>*/}
                    {/*
                    {/*</Card>*/}

                    {/*<Card*/}
                    {/*    sx={{*/}
                    {/*        width: "350px",*/}
                    {/*        borderRadius: "12px",*/}
                    {/*        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2)",*/}
                    {/*        textAlign: "center",*/}
                    {/*        padding: 2,*/}
                    {/*        backgroundColor: "#fff",*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>*/}
                    {/*        <Rating*/}
                    {/*            value={0}*/}
                    {/*            max={3}*/}
                    {/*            readOnly*/}
                    {/*            icon={<span style={{ color: "#FFD700", fontSize: "80px" }}>★</span>}*/}
                    {/*            emptyIcon={<span style={{ color: "#E0E0E0", fontSize: "80px" }}>★</span>}*/}
                    {/*        />*/}
                    {/*    </Box>*/}

                    {/*    <Typography variant="h4" className={classes.cardTitle}>*/}
                    {/*        Digital-Safety-by-Design Rating*/}
                    {/*    </Typography>*/}

                    {/*    <Typography variant="body1" sx={{ color: "#666", marginTop: 2, marginBottom: 4 }}>*/}
                    {/*        Check your program’s Digital-Safety-by-Design rating to see what*/}
                    {/*        regulations your program complies with locally and globally.*/}
                    {/*    </Typography>*/}
                    {/*    <Button*/}
                    {/*        variant="contained"*/}
                    {/*        sx={{*/}
                    {/*            marginBottom: 2,*/}
                    {/*            textTransform: "none",*/}
                    {/*            background: "linear-gradient(to left, #E7466E 35%, #FFAC46 190%) !important",*/}
                    {/*            color: '#fff',*/}
                    {/*            '&:hover': {*/}
                    {/*                background: "linear-gradient(to left, #E7466E 35%, #FFAC46 190%) !important",*/}
                    {/*            },*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        Check Rating*/}
                    {/*    </Button>*/}
                    {/*</Card>*/}
                {/*</Box>*/}
            </Box>
        </>
    );
}

export default CPCRatedProgram;